import * as React from "react";
import { cn } from "../cn";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => (
    <input
      type={type}
      ref={ref}
      className={cn(
        "flex h-10 w-full rounded-[var(--radius)] px-3 py-2 text-sm",
        "bg-[var(--color-panel-raised)] border border-[var(--color-panel-border)]",
        "text-[var(--color-ink)] placeholder:text-[var(--color-ink-muted)]",
        "transition-colors duration-150",
        "hover:border-[var(--color-panel-border)]/80",
        "focus:outline-none focus:border-[var(--color-amber)] focus:shadow-[var(--shadow-amber)]",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "file:border-0 file:bg-transparent file:text-sm file:font-medium",
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";

export { Input };
